export default __webpack_public_path__ + "static/media/Rampver_Financials_Unionbank_QR_2025.37bf5680.jpg";